/*
 * Module for handling of ajax navigation links
 */
rs.module("content/employer/reporting/paymentmethod/edit",

    [ "common/visibility", "ui/framework/client-templates" ],

    function (visibility, clientTemplates) {

        // initialize the module
        function initialize(jsSelectors, templateKeys, codeValues, backendUrl, employerKey) {
            var paymentMethodDiv = $.js(jsSelectors.paymentMethodDiv);

            var paymentMethodSelect = paymentMethodDiv.js(jsSelectors.paymentMethodSelect);
            var addressSelect = paymentMethodDiv.js(jsSelectors.addressSelect);
            var addressContent = paymentMethodDiv.js(jsSelectors.addressContent);
            var achSection = paymentMethodDiv.js(jsSelectors.achSection);
            var checkSection = paymentMethodDiv.js(jsSelectors.checkSection);

            paymentMethodSelect.change(paymentMethodChanged);
            addressSelect.change(addressTypeChanged);
            paymentMethodChanged();

            // update UI after payment method change
            function paymentMethodChanged() {
                visibility.setVisible(achSection, paymentMethodSelect.val() == codeValues.achCode);
                visibility.setVisible(checkSection, paymentMethodSelect.val() == codeValues.checkCode);

                addressTypeChanged();
            }

            // update UI after address type change
            function addressTypeChanged() {
                $.getJSON(backendUrl, { ownerKey: employerKey, addressType: addressSelect.val() }).done(function (data) {
                    addressContent.html(clientTemplates.render(templateKeys.addressTemplate, data));
                });
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);